export default {
	setSession (context, payload){
		context.commit('SET_SESSION', payload)
	},

	setConfig (context, payload){
		context.commit('SET_CONFIG', payload)
	},

	setBaseURL (context, payload){
		context.commit('SET_BASE_URL', payload)
	},

	setWebSocket(context, payload){
		context.commit('SET_WEBSOCKET', payload)
	}
}



// WEBPACK FOOTER //
// ./src/store/sessao/actions.js